import { render, staticRenderFns } from "./mainTitle.vue?vue&type=template&id=474dc901&"
import script from "./mainTitle.vue?vue&type=script&lang=js&"
export * from "./mainTitle.vue?vue&type=script&lang=js&"
import style0 from "./mainTitle.vue?vue&type=style&index=0&id=474dc901&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports